import React from "react";
import { Award, Info } from "lucide-react";
import { Panel, TitledPanel, EmptyState } from "@/portal/ui/Layout";
import { Badge, StatusBadge, QUALITY_KIND, QUALITY_RESULT } from "@/portal/ui/Badge";
import { fmtDateHuman } from "@/portal/format";

export default function QualityTab({ portal }) {
  const items = [...(portal?.quality || [])].sort((a, b) => (b.date || "").localeCompare(a.date || ""));
  const health = portal?.health?.quality;
  if (items.length === 0) return <EmptyState icon={Award} title="Registrul de calitate nu a fost încă publicat" description="Inspecțiile, testele și recepțiile parțiale vor fi publicate aici de echipa Brisk." testid="quality-empty" />;
  const passed = items.filter((i) => i.result === "passed").length;
  const open = items.filter((i) => i.result === "open").length;
  const failed = items.filter((i) => i.result === "failed").length;
  const nc = items.filter((i) => i.kind === "nonconformity" && i.result !== "closed").length;

  return (
    <div className="grid grid-cols-1 xl:grid-cols-[1fr_300px] gap-5 items-start">
      <div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-5" data-testid="quality-kpis">
          <Kpi label="Verificări conforme" value={passed} tone="text-cp-success" />
          <Kpi label="În lucru" value={open} tone={open ? "text-cp-warning" : ""} />
          <Kpi label="Neconforme" value={failed} tone={failed ? "text-cp-danger" : ""} />
          <Kpi label="Neconformități active" value={nc} tone={nc ? "text-cp-danger" : ""} />
        </div>
        <Panel padded={false} className="overflow-x-auto" data-testid="quality-table">
          <table className="cp-table min-w-[720px]">
            <thead><tr><th>Verificare</th><th>Tip</th><th>Locație</th><th>Dată</th><th>Rezultat</th></tr></thead>
            <tbody>
              {items.map((q) => (
                <tr key={q.id} data-testid={`quality-${q.id}`}>
                  <td className="max-w-[320px]"><div className="text-[14px] font-medium text-cp-text">{q.title}</div>{q.note && <div className="cp-meta mt-0.5">{q.note}</div>}</td>
                  <td><Badge tone="neutral" size="sm">{QUALITY_KIND[q.kind] || q.kind}</Badge></td>
                  <td>{q.location || "—"}</td>
                  <td className="whitespace-nowrap">{fmtDateHuman(q.date)}</td>
                  <td><StatusBadge map={QUALITY_RESULT} value={q.result} fallback="open" size="sm" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </Panel>
      </div>
      <div className="space-y-4">
        {health && (
          <TitledPanel title="Evaluarea PM" testid="quality-health">
            <StatusBadge map={{ "On Track": { label: "Calitate conformă", tone: "success" }, "Attention Required": { label: "Necesită atenție", tone: "warning" }, "Critical": { label: "Critic", tone: "danger" } }} value={health.level} />
            <p className="cp-body-sm mt-3">{health.note || "Verificările de calitate se desfășoară conform planului de control."}</p>
          </TitledPanel>
        )}
        <div className="cp-panel-soft p-4 flex gap-3 text-[13px] text-cp-text-2">
          <Info className="h-4 w-4 text-cp-accent shrink-0 mt-0.5" aria-hidden="true" />
          <p>Registrul include inspecții, teste de laborator, recepții parțiale și neconformitățile constatate, împreună cu stadiul remedierii.</p>
        </div>
      </div>
    </div>
  );
}

function Kpi({ label, value, tone }) {
  return <div className="cp-panel px-4 py-3.5"><div className="text-[12.5px] text-cp-text-2">{label}</div><div className={`cp-metric mt-1 ${tone}`}>{String(value).padStart(2, "0")}</div></div>;
}
